module.exports = __webpack_public_path__ + "static/media/IntroToTensorflow.7186698b.png";